import type { PostMessageData } from './message-protocol';
import { MESSAGE_TYPES } from './message-protocol';
import type { Action } from './actions';

/**
 * Protocol version for Unified Action Protocol
 */
export const PROTOCOL_VERSION = '1.0';

/**
 * Generate a unique request ID
 */
export function generateRequestId(): string {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
}

/**
 * Create a PostMessage message with standard structure
 */
export function createMessage<T = any>(
  type: string,
  payload?: T,
  requestId?: string
): PostMessageData {
  return {
    type,
    payload,
    requestId: requestId || generateRequestId(),
    timestamp: Date.now(),
    version: PROTOCOL_VERSION,
  };
}

/**
 * Create an ACTION_REQUEST message
 */
export function createActionRequest(
  action: Action,
  params: Record<string, any> = {},
  requestId?: string
): PostMessageData {
  return createMessage(
    MESSAGE_TYPES.ACTION_REQUEST,
    {
      action,
      params,
    },
    requestId
  );
}
